<button
  app-vtmn-play-icon-button
  type="button"
  *ngIf="!isAuthenticated"
  data-test="login-connect-button"
  class="header-login"
  [ngClass]="variantClass"
  [size]="vtmnPlayIconButtonSize.LARGE"
  [variant]="vtmnPlayIconButtonVariant.TERTIARY"
  [type]="ctaButtonType.Button"
  aria-label="login"
  (click)="onClick()"
>
  <vtmn-play-icon
    [ariaLabel]="'header.login.button.text' | translate"
    [name]="accountIcon"
  ></vtmn-play-icon>
</button>

<ng-container *ngIf="isAuthenticated">
  <button
    [id]="buttonId"
    class="header-login header-login--authenticated"
    [ngClass]="variantClass"
    type="button"
    aria-haspopup="true"
    [attr.aria-controls]="menuId"
    [attr.aria-expanded]="isOpen"
    (click)="toggleMenu()"
    data-test="logged-button"
  >
    <span
      class="flex items-center text-center justify-center w-6 h-6 rounded-full text-xl text-white uppercase bg-blue-gradient"
    >
      <ng-container *ngIf="user.initials; else noInitials">
        <span class="header-login__icon">{{ user.initials }}</span>
      </ng-container>
      <ng-template #noInitials>
        <vtmn-play-icon
          [ariaLabel]="'header.login.button.menu_icon' | translate"
          class="header-login__icon"
          [name]="accountIcon"
        ></vtmn-play-icon>
      </ng-template>
    </span>

    <span class="header-login__text">
      <vtmn-play-icon
        [ariaLabel]="'header.login.button.menu_icon' | translate"
        [name]="menuIcon"
      ></vtmn-play-icon>
    </span>
  </button>

  <app-header-login-menu
    [id]="menuId"
    [attr.aria-labelledby]="buttonId"
    [isOpen]="isOpen"
    [lists]="menuItems"
    [user]="user"
    [variant]="variant"
  ></app-header-login-menu>
</ng-container>
